export const OperationType = Object.freeze({
    Venda: 1,
    Compra: 2,
    Ambos: 3
})